<!-- lazy load component -->
<ng-container *ngIf="selector" [appLazyDirective]="lazy_config" [inputs]="inputs" [outputs]="outputs" />
